module.exports = __webpack_public_path__ + "img/fallback_icon.fe14b569.png";